import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-nc': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8C387.4 8 496 115.9 496 256 496 403.2 377.5 504 247.6 504 113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1C48.4 209.5 44.7 231.8 44.7 256 44.7 366.9 136.8 458.4 248.4 458.4 370.8 458.4 425.6 356.6 426.9 354.3L333.5 312.7C325.8 349.8 292.3 365.7 265.3 368.1V406.2H236.5V368C209 367.7 183.9 357.8 161.2 338.3L195.3 303.8C227 333.2 281.7 335.6 281.7 301.6 281.7 295.4 279.5 290.4 275.1 286.5 260.9 280.5 273.3 286.4 55.8 189.1zM248.4 52.3C210 52.3 136 61 77.9 145.3L172.7 187.8C182.7 156.5 213.1 144.9 236.5 143.5V105.4H265.3V143.5C288 144.7 308.7 152.4 327.3 166.5L295 199.7C252.3 169.8 211.5 191.7 225 210.8 278.4 234.9 268.8 230.6 318 252.4L445.1 309.1C449.2 291.7 451.3 274 451.3 256 451.3 199 431.5 151 392 112.1 352.7 72.2 304.8 52.3 248.4 52.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-nc.js
// module id = CIbX
// module chunks = 144